import { SVGProps } from "react";

export const DrawingTableIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="currentColor" // inherit color from parent
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M4.62508 15.8332L1.66675 12.8749L2.83341 11.7082L4.60425 13.479L8.14592 9.93736L9.31258 11.1249L4.62508 15.8332ZM4.62508 9.16652L1.66675 6.20819L2.83341 5.04152L4.60425 6.81236L8.14592 3.27069L9.31258 4.45819L4.62508 9.16652ZM10.8334 14.1665V12.4999H18.3334V14.1665H10.8334ZM10.8334 7.49986V5.83319H18.3334V7.49986H10.8334Z" />
  </svg>
);
